import Vue from 'vue'
import VueRouter from 'vue-router'
import homeRouter from './home'
import hebeiRouter from './hebei'
import api from '../api/api.js'
import store from '../store'
Vue.use(VueRouter)
const router = new VueRouter({
    mode: 'history',
    routes: [
        homeRouter,
        hebeiRouter,
        {
            path: '*',
            component: resolve => require(['../views/error/error_404'], resolve)
        },
        {
            path: '/500',
            component: () =>
                import('../views/error/error_500'),
        },
        {
            path: '/',
            component: () =>
                import('../views/hebei.vue'),
            meta: {
                title: '河北省残疾人就业创业网络服务平台——中国残联官方残疾人求职网站',
                requireAuth: false,
            },
        },
        {
            path: '/center/disabledVideos',
            component: () =>
                import ('../views/videos/disabledVideos.vue'),
            meta: {
                title: '面试间-河北省残疾人就业创业网络服务平台',
                requireAuth: true,
                userType: 1
            }
        },

        {
            path: '/Login',
            component: () =>
                import('../views/Login'),
            title: '残疾人登录',
            meta: {
                title: '残疾人登录',
                requireAuth: false,
            }
        },
        {
            path: '/user/companyLogin',
            component: () =>
                import('../views/company_login'),
            title: '企业登录',
            meta: {
                title: '企业登录',
                requireAuth: false,
            }
        },
        {
            path: '/user/password',
            component: () =>
                import('../components/public/FindPassword'),
            meta: {
                title: '注册',
                requireAuth: false
            }
        },
        {
            path: '/weixinLogin',
            component: () =>
                import('../views/userLogin/weixinLogin'),
            meta: {
                title: '微信登录',
                requireAuth: false
            }
        }, 
        {
            path: '/videoJob',
            name: 'videoJob',
            component: () =>
                import('../views/VideoJob.vue'),
            meta: {
                title: '网络招聘会',
                requireAuth: false
            },
        },
        {
            path: '/jobVideo',
            name: 'flexible',
            component: () =>
                import('../views/flexible.vue'),
            meta: {
                title: '灵活就业',
                requireAuth: false
            },
        },
        {
            path: '/public/jobFairIntroduction',
            name: 'jobFairIntroduction',
            component: () =>
                import('../views/public/jobFairIntroduction.vue'),
            meta: {
                title: '企业-企业招聘会指南',
                requireAuth: false
            },
        },
        {
            path: '/question',
            name: 'question',
            component: () =>
                import('../views/question/question'),
            meta: {
                title: '问卷调查',
                requireAuth: false
            },
        },
        {
            path: '/actionPlan',
            name: 'actionPlan',
            component: () =>
                import('../views/actionPlan/index'),
            meta: {
                title: '',
                requireAuth: false
            },
        },
        {
            path: '/actionPlan/success',
            name: 'actionPlanSuccess',
            component: () =>
                import('../views/actionPlan/success'),
            meta: {
                title: '',
                requireAuth: false
            },
        },
    ],
})

//获取子站传递过来的token
router.beforeEach(async (to, from, next) => {
    if (to.query.token) {
        localStorage.setItem('access_token', to.query.token);
        // 刷新个人信息
        let res = await api.loginRefreshApi();
        if (res.data.success) {
            let user = res.data.data;
            let userInfo = user;
            store.commit("SET_USER_INFO", userInfo);
            if (userInfo.userType === "2") {
                next({
                    path: "/enterprise",
                })
            } else {
                next({
                    path: "/",
                })
            }
        } else {
            next('/');
        }
    }else{
        next();
    }
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default router
